import { reduxBatch } from "@manaflair/redux-batch";
import {
  combineReducers,
  configureStore,
  getDefaultMiddleware,
} from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import createSagaMiddleware from "redux-saga";
import rootSaga from "../sagas/index";
import auth from "redux/reducers/Auth";
import theme from "redux/reducers/Theme";
import lookup from "redux/reducers/Lookup";
import Notification from "redux/reducers/Notifications";
import ApiMessageResponse from "redux/reducers/ApiMessageResponse";

const persistConfig = {
  key: "capmas",
  storage,
  blacklist: ['auth','notifications','apiMessageResponse'],
};
const authPersistConfig = {
  key: "capmas-auth",
  storage,
  blacklist: ["loading","message","showMessage"],
};

const sagaMiddleware = createSagaMiddleware();
const middleware = [
  ...getDefaultMiddleware({
    immutableCheck: false,
    serializableCheck: false,
    thunk: true,
  }),
  sagaMiddleware,
];
const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, auth),
  theme: theme,
  lookup: lookup,
  notifications:Notification,
  apiMessageResponse: ApiMessageResponse,

});
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware,
  devTools: process.env.NODE_ENV !== "production",
  enhancers: [reduxBatch],
});
/**
 * @see https://github.com/rt2zz/redux-persist#persiststorestore-config-callback
 * @see https://github.com/rt2zz/redux-persist#persistor-object
 */
export const persistor = persistStore(store);

sagaMiddleware.run(rootSaga);

export default store;
